import { COMPANY_FIELDS, GENERAL_FIELDS } from './applicantCompany';
import FilmClassificationforPublicDistribution from './Distribution';
import FilmClassificationforPublicExhibition from './Exhibition';
import RCAFlow from './RCA';
import CARegistration from './CA';
import APPLICATION_DELETE from '../applicationDelete';
import SUMMARY from '../Summary';
import { CASE_TYPE_ID } from 'common/constants';

export const FILMS = [
    {
        title: 'Films',
        steps: ['Application Details', 'Review'],
        caseType: CASE_TYPE_ID.FILMS,
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'ApplicationDetails',
        actionReview: 'ReviewFVGScreen',
        forms: [
            {
                formID: 'generalApplicant',
                title: 'Applicant Details',
                fields: GENERAL_FIELDS,
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'generalCompany',
                title: 'Applicant/Organisation Details',
                fields: COMPANY_FIELDS,
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'application-delete',
                title: '',
                fields: APPLICATION_DELETE
            },
            ...FilmClassificationforPublicExhibition,
            ...FilmClassificationforPublicDistribution,
            ...RCAFlow,
            ...CARegistration,
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY
            }
        ]
    }
];
